import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _initializerDefineProperty from "@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/esm/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/esm/initializerWarningHelper";
var _dec, _class, _descriptor;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { BlendType, gl, lazyInject, MaskOperation, StencilType, TYPES } from '@antv/l7-core';
import { rgb2arr } from '@antv/l7-utils';
import { color } from 'd3-color';
import { isEqual, isNumber, isString } from 'lodash';
import { BlendTypes } from "../utils/blend";
import { getStencil as _getStencil, getStencilMask } from "../utils/stencil";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var BaseModel = (_dec = lazyInject(TYPES.IGlobalConfigService), (_class = /*#__PURE__*/function () {
  // style texture data mapping

  // 用于数据传递的数据纹理
  // 默认有多少列（宽度）
  // 计算得到的当前数据纹理有多少行（高度）

  // 单个 cell 的长度
  // 需要进行数据映射的属性集合

  // style texture data mapping

  function BaseModel(layer) {
    _classCallCheck(this, BaseModel);
    _initializerDefineProperty(this, "configService", _descriptor, this);
    this.layer = layer;
    this.rendererService = layer.getContainer().get(TYPES.IRendererService);
    this.pickingService = layer.getContainer().get(TYPES.IPickingService);
    this.shaderModuleService = layer.getContainer().get(TYPES.IShaderModuleService);
    this.styleAttributeService = layer.getContainer().get(TYPES.IStyleAttributeService);
    this.mapService = layer.getContainer().get(TYPES.IMapService);
    this.iconService = layer.getContainer().get(TYPES.IIconService);
    this.fontService = layer.getContainer().get(TYPES.IFontService);
    this.cameraService = layer.getContainer().get(TYPES.ICameraService);
    this.layerService = layer.getContainer().get(TYPES.ILayerService);

    // 注册 Attribute
    this.registerBuiltinAttributes();
    // 开启动画
    this.startModelAnimate();
    var createTexture2D = this.rendererService.createTexture2D;
    this.createTexture2D = createTexture2D;
    this.DATA_TEXTURE_WIDTH = 1024; // 数据纹理固定宽度
    this.rowCount = 1;
    this.cellLength = 0;
    this.cellProperties = [];
    this.cacheStyleProperties = {
      thetaOffset: undefined,
      opacity: undefined,
      strokeOpacity: undefined,
      strokeWidth: undefined,
      stroke: undefined,
      offsets: undefined
    };
    this.stylePropertiesExist = {
      hasThetaOffset: 0,
      hasOpacity: 0,
      hasStrokeOpacity: 0,
      hasStrokeWidth: 0,
      hasStroke: 0,
      hasOffsets: 0
    };
    this.dataTextureTest = this.layerService.getOESTextureFloat();
    // 只有在不支持数据纹理的情况下进行赋值
    if (!this.dataTextureTest) {
      this.dataTexture = this.createTexture2D({
        // data: new Uint8ClampedArray(4),
        // 使用 Uint8ClampedArray 在 支付宝 环境中可能存在问题 UC 内核对格式有要求 L7 v2.7.18 版本发现
        // Uint8ClampedArray 和 Uint8Array 没有实质性的区别
        data: new Uint8Array(4),
        mag: gl.NEAREST,
        min: gl.NEAREST,
        width: 1,
        height: 1
      });
    }
  }

  // style datatexture mapping

  /**
   * 清除上一次的计算结果 - 全量清除
   */
  _createClass(BaseModel, [{
    key: "clearLastCalRes",
    value: function clearLastCalRes() {
      this.cellProperties = []; // 清空上一次计算的需要进行数据映射的属性集合
      this.cellLength = 0; // 清空上一次计算的 cell 的长度
      this.stylePropertiesExist = {
        // 全量清空上一次是否需要对 style 属性进行数据映射的判断
        hasThetaOffset: 0,
        hasOpacity: 0,
        hasStrokeOpacity: 0,
        hasStrokeWidth: 0,
        hasStroke: 0,
        hasOffsets: 0
      };
    }
  }, {
    key: "getCellTypeLayout",
    value: function getCellTypeLayout() {
      if (this.dataTextureTest) {
        return [
        // 0
        this.rowCount,
        // 数据纹理有几行
        this.DATA_TEXTURE_WIDTH,
        // 数据纹理有几列
        0.0, 0.0,
        // 1
        this.stylePropertiesExist.hasOpacity,
        // cell 中是否存在 opacity
        this.stylePropertiesExist.hasStrokeOpacity,
        // cell 中是否存在 strokeOpacity
        this.stylePropertiesExist.hasStrokeWidth,
        // cell 中是否存在 strokeWidth
        this.stylePropertiesExist.hasStroke,
        // cell 中是否存在 stroke
        // 2
        this.stylePropertiesExist.hasOffsets,
        // cell 中是否存在 offsets
        this.stylePropertiesExist.hasThetaOffset,
        // cell 中是否存在 thetaOffset
        0.0, 0.0,
        // 3
        0.0, 0.0, 0.0, 1.0];
      } else {
        return [1.0,
        // 数据纹理有几行
        1.0,
        // 数据纹理有几列
        0.0, 0.0, 0.0,
        // cell 中是否存在 opacity
        0.0,
        // cell 中是否存在 strokeOpacity
        0.0,
        // cell 中是否存在 strokeWidth
        0.0,
        // cell 中是否存在 stroke
        0.0,
        // cell 中是否存在 offsets
        0.0, 0.0, 0.0, 0.0, 0.0, 0.0, -1.0];
      }
    }

    /**
     * 判断数据纹理是否需要重新计算 - 根据传入的值进行判断
     * @param options
     * @returns
     */
  }, {
    key: "dataTextureNeedUpdate",
    value: function dataTextureNeedUpdate(options) {
      var isUpdate = false;
      if (!isEqual(options.thetaOffset, this.cacheStyleProperties.thetaOffset)) {
        isUpdate = true;
        this.cacheStyleProperties.thetaOffset = options.thetaOffset;
      }
      if (!isEqual(options.opacity, this.cacheStyleProperties.opacity)) {
        isUpdate = true;
        this.cacheStyleProperties.opacity = options.opacity;
      }
      if (!isEqual(options.strokeOpacity, this.cacheStyleProperties.strokeOpacity)) {
        isUpdate = true;
        this.cacheStyleProperties.strokeOpacity = options.strokeOpacity;
      }
      if (!isEqual(options.strokeWidth, this.cacheStyleProperties.strokeWidth)) {
        isUpdate = true;
        this.cacheStyleProperties.strokeWidth = options.strokeWidth;
      }
      if (!isEqual(options.stroke, this.cacheStyleProperties.stroke)) {
        isUpdate = true;
        this.cacheStyleProperties.stroke = options.stroke;
      }
      if (!isEqual(options.offsets, this.cacheStyleProperties.offsets)) {
        isUpdate = true;
        this.cacheStyleProperties.offsets = options.offsets;
      }
      if (this.dataTexture === undefined) {
        isUpdate = true;
      }
      return isUpdate;
    }
    /**
     * 判断当前的样式中哪些是需要进行数据映射的，哪些是常量，同时计算用于构建数据纹理的一些中间变量
     * @param options
     */
  }, {
    key: "judgeStyleAttributes",
    value: function judgeStyleAttributes(options) {
      this.clearLastCalRes(); // 清除上一次的计算结果 - 全量清除

      if (options.opacity !== undefined && !isNumber(options.opacity)) {
        // 数据映射
        this.cellProperties.push({
          attr: 'opacity',
          count: 1
        });
        this.stylePropertiesExist.hasOpacity = 1;
        this.cellLength += 1;
      }
      if (options.strokeOpacity !== undefined && !isNumber(options.strokeOpacity)) {
        // 数据映射
        this.cellProperties.push({
          attr: 'strokeOpacity',
          count: 1
        });
        this.stylePropertiesExist.hasStrokeOpacity = 1;
        this.cellLength += 1;
      }
      if (options.strokeWidth !== undefined && !isNumber(options.strokeWidth)) {
        // 数据映射
        this.cellProperties.push({
          attr: 'strokeWidth',
          count: 1
        });
        this.stylePropertiesExist.hasStrokeWidth = 1;
        this.cellLength += 1;
      }
      if (options.stroke !== undefined && !this.isStaticColor(options.stroke)) {
        // 数据映射
        this.cellProperties.push({
          attr: 'stroke',
          count: 4
        });
        this.stylePropertiesExist.hasStroke = 1;
        this.cellLength += 4;
      }
      if (options.offsets !== undefined && !this.isOffsetStatic(options.offsets)) {
        // 数据映射
        this.cellProperties.push({
          attr: 'offsets',
          count: 2
        });
        this.stylePropertiesExist.hasOffsets = 1;
        this.cellLength += 2;
      }
      if (options.thetaOffset !== undefined && !isNumber(options.thetaOffset)) {
        // 数据映射
        this.cellProperties.push({
          attr: 'thetaOffset',
          count: 1
        });
        this.stylePropertiesExist.hasThetaOffset = 1;
        this.cellLength += 1;
      }
    }

    /**
     * 判断变量 stroke 是否是常量值
     * @param stroke
     * @returns
     */
  }, {
    key: "isStaticColor",
    value: function isStaticColor(stroke) {
      if (isString(stroke)) {
        if (color(stroke)) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    }
    /**
     * 获取 stroke 颜色并做兼容处理
     * @param stroke
     * @returns
     */
  }, {
    key: "getStrokeColor",
    value: function getStrokeColor(stroke) {
      if (this.isStaticColor(stroke)) {
        var strokeColor = rgb2arr(stroke);
        strokeColor[0] = strokeColor[0] ? strokeColor[0] : 0;
        strokeColor[1] = strokeColor[1] ? strokeColor[1] : 0;
        strokeColor[2] = strokeColor[2] ? strokeColor[2] : 0;
        strokeColor[3] = strokeColor[3] ? strokeColor[3] : 0;
        return strokeColor;
      } else {
        return [0, 0, 0, 0];
      }
    }

    /**
     * 判断 offsets 是否是常量
     * @param offsets
     * @returns
     */
  }, {
    key: "isOffsetStatic",
    value: function isOffsetStatic(offsets) {
      if (Array.isArray(offsets) && offsets.length === 2 && isNumber(offsets[0]) && isNumber(offsets[1])) {
        return true;
      } else {
        return false;
      }
    }

    /**
     * 补空位
     * @param d
     * @param count
     */
  }, {
    key: "patchMod",
    value: function patchMod(d, count) {
      for (var i = 0; i < count; i++) {
        d.push(-1);
      }
    }

    /**
     * 根据映射的数据字段往推入数据
     * @param d
     * @param cellData
     * @param cellPropertiesLayouts
     */
  }, {
    key: "patchData",
    value: function patchData(d, cellData, cellPropertiesLayouts) {
      var _iterator = _createForOfIteratorHelper(cellPropertiesLayouts),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var layout = _step.value;
          var attr = layout.attr,
            count = layout.count;
          var value = cellData[attr];
          if (value !== undefined) {
            // 数据中存在该属性
            if (attr === 'stroke') {
              d.push.apply(d, _toConsumableArray(rgb2arr(value)));
            } else if (attr === 'offsets') {
              if (this.isOffsetStatic(value)) {
                d.push(-value[0], value[1]);
              } else {
                d.push(0, 0);
              }
            } else {
              d.push(isNumber(value) ? value : 1.0);
            }
          } else {
            // 若不存在时则补位
            this.patchMod(d, count);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * 计算推入数据纹理的数据
     * @param cellLength
     * @param encodeData
     * @param cellPropertiesLayouts
     * @returns
     */
  }, {
    key: "calDataFrame",
    value: function calDataFrame(cellLength, encodeData, cellPropertiesLayouts) {
      var encodeDatalength = encodeData.length;
      var rowCount = Math.ceil(encodeDatalength * cellLength / this.DATA_TEXTURE_WIDTH); // 有多少行

      var totalLength = rowCount * this.DATA_TEXTURE_WIDTH;
      var d = [];
      for (var i = 0; i < encodeDatalength; i++) {
        // 根据 encodeData 数据推入数据
        var cellData = encodeData[i];
        this.patchData(d, cellData, cellPropertiesLayouts);
      }
      for (var _i = d.length; _i < totalLength; _i++) {
        // 每行不足的部分用 -1 补足（数据纹理时 width * height 的矩形数据集合）
        d.push(-1);
      }
      // console.log('data', d)
      return {
        data: d,
        width: this.DATA_TEXTURE_WIDTH,
        height: rowCount
      };
    }

    // style datatexture mapping
  }, {
    key: "getBlend",
    value: function getBlend() {
      var _this$layer$getLayerC = this.layer.getLayerConfig(),
        _this$layer$getLayerC2 = _this$layer$getLayerC.blend,
        blend = _this$layer$getLayerC2 === void 0 ? 'normal' : _this$layer$getLayerC2;
      return BlendTypes[BlendType[blend]];
    }
  }, {
    key: "getStencil",
    value: function getStencil(option) {
      var _this$layer$getLayerC3 = this.layer.getLayerConfig(),
        _this$layer$getLayerC4 = _this$layer$getLayerC3.mask,
        mask = _this$layer$getLayerC4 === void 0 ? false : _this$layer$getLayerC4,
        _this$layer$getLayerC5 = _this$layer$getLayerC3.maskInside,
        maskInside = _this$layer$getLayerC5 === void 0 ? true : _this$layer$getLayerC5,
        enableMask = _this$layer$getLayerC3.enableMask,
        _this$layer$getLayerC6 = _this$layer$getLayerC3.maskOperation,
        maskOperation = _this$layer$getLayerC6 === void 0 ? MaskOperation.AND : _this$layer$getLayerC6;
      // TODO 临时处理，后期移除MaskLayer
      if (this.layer.type === 'MaskLayer') {
        return getStencilMask({
          isStencil: true,
          stencilType: StencilType.SINGLE
        }); // 用于遮罩的stencil 参数
      }

      if (option.isStencil) {
        return getStencilMask(_objectSpread(_objectSpread({}, option), {}, {
          maskOperation: maskOperation
        })); // 用于遮罩的stencil 参数
      }

      var maskflag = mask ||
      //  mask 兼容历史写法
      enableMask && this.layer.masks.length !== 0 ||
      // 外部图层的mask
      this.layer.tileMask !== undefined; // 瓦片图层
      // !!(mask || enableMask || this.layer.tileMask);
      return _getStencil(maskflag, maskInside);
    }
  }, {
    key: "getDefaultStyle",
    value: function getDefaultStyle() {
      return {};
    }
  }, {
    key: "getUninforms",
    value: function getUninforms() {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "getAnimateUniforms",
    value: function getAnimateUniforms() {
      return {};
    }
  }, {
    key: "needUpdate",
    value: function () {
      var _needUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", false);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function needUpdate() {
        return _needUpdate.apply(this, arguments);
      }
      return needUpdate;
    }() // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "buildModels",
    value: function () {
      var _buildModels = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              throw new Error('Method not implemented.');
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function buildModels() {
        return _buildModels.apply(this, arguments);
      }
      return buildModels;
    }() // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "initModels",
    value: function () {
      var _initModels = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              throw new Error('Method not implemented.');
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function initModels() {
        return _initModels.apply(this, arguments);
      }
      return initModels;
    }() // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "clearModels",
    value: function clearModels() {
      var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return;
    }
  }, {
    key: "getAttribute",
    value: function getAttribute() {
      throw new Error('Method not implemented.');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "render",
    value: function render(renderOptions) {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "registerBuiltinAttributes",
    value: function registerBuiltinAttributes() {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "animateOption2Array",
    value: function animateOption2Array(option) {
      return [option.enable ? 0 : 1.0, option.duration || 4.0, option.interval || 0.2, option.trailLength || 0.1];
    }
  }, {
    key: "startModelAnimate",
    value: function startModelAnimate() {
      var _ref = this.layer.getLayerConfig(),
        animateOption = _ref.animateOption;
      if (animateOption.enable) {
        this.layer.setAnimateStartTime();
      }
    }
  }]);
  return BaseModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "configService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { BaseModel as default };